<template>
  <tr @click="handleClickOnRow()" :class="{
    'selected-row': documentItem.isSelected && (documentItem.status === recognitionStatus.Failed || documentItem.status === recognitionStatus.PendingReview),
    'cursor-pointer': documentItem.status === recognitionStatus.Failed || documentItem.status === recognitionStatus.PendingReview,
    'no-hover': documentItem.status !== recognitionStatus.Failed && documentItem.status !== recognitionStatus.PendingReview,
  }">
    <td class="pl-2 pr-2" style="position: relative;">
      <div class="triangle-container">
        <div class="triangle" v-if="documentItem.controlTakenByUserID"
          :style="documentTakenByMe() ? 'border-top-color: #FFCA28;' : 'border-top-color: #D50000;'">
          <div class="icon-container">

            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" x-small color="white">
                  {{ documentTakenByMe() ? 'mdi-lock' : 'mdi-account-lock' }}
                </v-icon>
              </template>
              <span>{{ documentTakenByMe() ? $t("BlockedByMe") : $t("BlockedByOtherUser") }}</span>
            </v-tooltip>
          </div>
        </div>
        <v-icon
          v-if="documentItem.status === recognitionStatus.Failed || documentItem.status === recognitionStatus.PendingReview"
          @click.stop="deleteDocument" color="red accent-4">
          mdi-delete
        </v-icon>
      </div>
    </td>
    <td class="fileName-width pl-0 pb-1 caption">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <span class="truncate pt-3" v-on="on">
            {{ documentItem.originalFileName }}

            <small class="grey--text caption d-block">
              {{ $t("Source") }}: {{ getSourceNameByEnum(documentItem.provider) }}
            </small>
            <small class="grey--text caption d-block">
              {{ utils.date.toUserFormatFromIso(documentItem.importDate) }}
            </small>
          </span>
        </template>
        <span>{{ documentItem.originalFileName }}</span>
      </v-tooltip>
    </td>
    <td class="provider-width text-left caption pt-1">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <span class="truncate caption" v-on="on">
            {{ documentItem.contentTypeName }}
          </span>
        </template>
        <span>{{ documentItem.contentTypeName }}</span>
      </v-tooltip>
    </td>
    <td class="pl-2 pr-2 text-center">
      <DocumentStatusIcon :status="documentItem.status"></DocumentStatusIcon>
    </td>
  </tr>
</template>

<script>
import DocumentStatusIcon from "@/components/aiRecognition/Components/DocumentStatusIcon.vue";
import RecognitionStatus from "@/ecm/variables/RecognitionStatus";
import Utils from "@/ecm/common/Utils";
import DocumentIntelligenceProvidersService from "@/services/DocumentIntelligenceProvidersService";
import BlockedDocumentsService from "@/ecm/models/contentType/documentIntelligence/BlockedDocumentsService.js"
import RemovePendingObjectSource from "@/ecm/variables/RemovePendingObjectSource.js";
import AutoImportSources from "../../../ecm/variables/AutoImportSources";

export default {
  components: { DocumentStatusIcon },
  props: {
    documentItem: {
      type: Object,
      required: true,
      default: {
        isDocumentTaken: false
      }
    },
    index: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data() {
    return {
      recognitionStatus: RecognitionStatus,
      currentUser: this.$store.getters["account/user"],
      utils: Utils,
      blockedDocumentsService: new BlockedDocumentsService(this),

    };
  },
  methods: {
    documentTakenByMe() {
      return this.documentItem.controlTakenByUserID === this.currentUser.Id;
    },

    handleDeleteDocument() {
      const messageId = this.documentItem.messageId;
      const status = this.documentItem.status;
      DocumentIntelligenceProvidersService.removeDocument(
        messageId,
        status,
        RemovePendingObjectSource.PendingObjectDeleted
      ).then((response) => {
        if (response) {
          this.$emit("on-document-deleted", messageId);

          Utils.toast.success(this.$t("DocumentDeletedSuccessfully"));

        } else {
          Utils.toast.error(this.$t("FailedToDeleteDocument"));
        }
      }).catch(() => {
        Utils.toast.error(this.$t("FailedToDeleteDocument"));
      });
    },

    async deleteDocument() {
      const result = await this.blockedDocumentsService.checkDocumentAvailability(this.documentItem.messageId);

      if (result != null && result.UserID !== this.currentUser.Id) {
        const optionResult = await this.blockedDocumentsService.confirmBlockAction(result, true);

        if (optionResult) {
          this.handleDeleteDocument(this.documentItem.messageId, this.documentItem.status);
        }

      } else {
        this.handleDeleteDocument(this.documentItem.messageId, this.documentItem.status);
      }
    },
    handleClickOnRow() {
      //Only allow to open the document if the status is pending review or failed
      if (this.documentItem.status !== RecognitionStatus.PendingReview && this.documentItem.status !== RecognitionStatus.Failed) {
        return;
      }

      this.$emit("on-document-click", this.documentItem, this.index);
    },
    getSourceNameByEnum(provider) {
      const providerName = AutoImportSources[provider];

      if (providerName) {
        return this.$t(providerName) || providerName;
      }

      return 'Unknown Provider';
    }
  }
}
</script>
